var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApcv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#007850;}.cls-3{fill:#f0f032;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "zone_protection",
    "data-name": "zone protection"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.87.45H6.73A5.67,5.67,0,0,0,1.08,6.11V56.88A2.9,2.9,0,0,0,4,59.78H45.6a2.94,2.94,0,0,0,2.93-2.93V6.11A5.67,5.67,0,0,0,42.87.45Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "logo_apcv_compatible",
    "data-name": "logo apcv compatible"
  }, /*#__PURE__*/React.createElement("g", {
    id: "version_compatible",
    "data-name": "version compatible"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 3.04,
    y: 47.62,
    width: 43.77,
    height: 10.38,
    rx: 1.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "comptaible_vectorise",
    "data-name": "comptaible vectorise"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.55,55.13a4.75,4.75,0,0,1-1.43.23,1.86,1.86,0,0,1-2-2V52.26a1.86,1.86,0,0,1,2-2,4.75,4.75,0,0,1,1.43.23l-.21.87a4.19,4.19,0,0,0-1.21-.19c-.58,0-1,.32-1,1.21v.88c0,.9.37,1.21,1,1.21a3.6,3.6,0,0,0,1.21-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.26,52.28a1.87,1.87,0,0,1,2-2.05,1.87,1.87,0,0,1,1.95,2.05v1a1.86,1.86,0,0,1-1.95,2,1.86,1.86,0,0,1-2-2Zm2.83,1v-.89c0-.89-.37-1.21-.88-1.21s-.88.32-.88,1.21v.89c0,.91.36,1.2.88,1.2S12.09,54.15,12.09,53.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.33,50.33h1.22l.84,2.38c.06.17.12.41.18.64a5.81,5.81,0,0,1,.17-.64l.85-2.38h1.22l.52,4.93H18.27l-.21-2.52c0-.26,0-.6,0-1a8.53,8.53,0,0,1-.27.94l-.6,1.7H16l-.61-1.7a8.53,8.53,0,0,1-.27-.94c0,.35,0,.69,0,1l-.21,2.52H13.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.1,50.33h1.75a1.57,1.57,0,1,1,0,3.13h-.68v1.8H20.1Zm1.72,2.24c.34,0,.57-.26.57-.67a.59.59,0,0,0-.57-.66h-.65v1.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.88,50.33h1.24l1.48,4.93H26.52l-.33-1.19H24.82l-.33,1.19H23.4ZM26,53.2l-.26-.93c-.06-.23-.13-.53-.19-.84-.06.31-.13.61-.19.84l-.25.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.72,51.24H27.53v-.91H31v.91H29.8v4H28.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.69,50.33h1.07v4.93H31.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.78,55.26V50.33h1.61c1,0,1.7.57,1.7,1.38a1,1,0,0,1-.63,1,1.1,1.1,0,0,1,.81,1.09,1.65,1.65,0,0,1-1.84,1.5Zm1.53-3c.45,0,.69-.23.69-.53s-.18-.53-.64-.53h-.51V52.3Zm.11,2.05c.48,0,.76-.26.76-.59s-.23-.59-.7-.59h-.63v1.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38,50.33H39.1v4h2l0,.91H38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.76,50.33h3v.91H42.84v1.09h1.57l0,.88H42.84v1.14h1.94v.91h-3Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 3.04,
    y: 1.99,
    width: 43.77,
    height: 43.77,
    rx: 5.63
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "3.04 7.62 13.93 30.5 26.21 1.99 38.56 1.99 19.1 45.76 8.81 45.76 3.04 34.44 3.04 7.62"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApcv);
export default __webpack_public_path__ + "static/media/apcv.8a0594f7232097ac1734287db871a369.svg";
export { ForwardRef as ReactComponent };